














































































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import { getLodop, demoDownloadPDF } from '@/common/js/LodopFuncs'
import Enums from '@/lib/enums'
import SettingCost from './setting-storecost.vue'
import SettingShelfUpCost from './deduct-shelfcost.vue'
import TotalInStock from './totalinstock-history.vue'
import TotalOutStock from './totaloutstock-history.vue'
import LaveStock from './lavestock-history.vue'
import BarCode from './barcode-show.vue'
import StockAdd from './stock-add.vue'
import EditShelfPosition from './shelfposition-edit.vue'
import LookSkuMapping from './skumapping-look.vue'
import BackPrinting from './back-printing.vue'
import BackAttachmentPrinting  from './back-attachment-printing.vue'
import PreStock from './prestock-add.vue'
import storeaddressInfo from '@/store/entities/back-storeaddress-list';
import DateUtils from '@/common/js/DateUtils'
import Preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import appconst from '@/lib/appconst';
import moment from 'moment'
Vue.use(Preview);

class PagebackstockproductRequest extends PageRequest {
    beginTime?: Date;
    endTime?: Date;
    productName: string;
    storeId?: number;
    productSku: string;
    barCode: string;
    userCode: string;
    productNo: string;
    minSafeStock?: number;
    maxSafeStock?: number;
    minStock?: number;
    maxStock?: number;
    stockstatus?: number;
    productId?: number;
    shelfPosition: string;
}

@Component({
    name: "backstockproduct",
    components: { SettingCost, SettingShelfUpCost, LookSkuMapping, TotalInStock, TotalOutStock, LaveStock, BarCode, StockAdd, BackPrinting, BackAttachmentPrinting, EditShelfPosition, PreStock }
})
export default class backstockproduct extends AbpBase {
    editModalShow: boolean = false;
    supplyModalShow: boolean = false;
    settingCostModalShow: boolean = false;
    settingshelfupCostModalShow: boolean = false;
    totalinstockModalShow: boolean = false;
    isLoadPrintList: boolean = false;
    totaloutstockModalShow: boolean = false;
    lookModalShow: boolean = false;
    codeModalShow: boolean = false;
    lavestockModalShow: boolean = false;
    stockaddShow: boolean = false;
    editShelfPositionModalShow: boolean = false;
    preStockModalShow: boolean = false;
    storeaddressList: Array<storeaddressInfo> = [];
    pagerequest: PagebackstockproductRequest = new PagebackstockproductRequest();
    IsCheckedStatus = Enums.getEnum(Enums.IsCheckStatus, true);
    stockstatusList = Enums.getEnum(Enums.StockStatus, true);
   // creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
    creationTime: Date[];
    printingModalShow: boolean = false;
    attachmentprintingModalShow: boolean = false;
    createModalShow: boolean = false;

    get list() {
        return this.$store.state.backstockproduct.list;
    };
    get loading() {
        return this.$store.state.backstockproduct.loading;
    }
    async add() {
        this.createModalShow = true;
    }
    @Watch('$route.params.productSku')
    productSkuChange() {
        var s = '';
        if (this.$route.params.productSku) {
            this.pagerequest = new PagebackstockproductRequest();
            this.pagerequest.productSku = this.$route.params.productSku;
            this.$store.state.backstockproduct.currentPage = 1;
            this.getpage();
        }

    }
    pageChange(page: number) {
        this.$store.commit('backstockproduct/setCurrentPage', page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit('backstockproduct/setPageSize', pagesize);
        this.getpage();
    }
    async searchPage() {
        this.$store.state.backstockproduct.currentPage = 1;
        this.getpage();
    }
    async InputStockNum(data: any) {
        if (!data.shelfPosition) {
            this.$Message.success("当前产品未上架！");
            return
        }
        this.$store.state.backstockproduct.id = data.id;
        this.stockaddShow = true;
    }
    async EditShelfPosition(data: any) {
        //if (!data.shelfPosition) {
        //    this.$Message.success("当前产品未上架！");
        //    return
        //}
        this.$store.state.backstockproduct.id = data.id;
        this.$store.state.backstockproduct.shelfPosition = data.shelfPosition;
        this.$store.state.backstockproduct.productName = data.productName;
        this.$store.state.backstockproduct.purchaseCost = data.purchaseCost;
        this.editShelfPositionModalShow = true;
    }
    async EditStockNum(data: any) {
        this.$store.state.backstockproduct.id = data.id;
        this.$store.state.backstockproduct.preStockNum = data.preStockNum;
        this.preStockModalShow = true;


    }
    async getpage() {

        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        //filters

        if (this.creationTime.length > 0) {
            this.pagerequest.beginTime = this.creationTime[0];
        }
        if (this.creationTime.length > 1) {
            this.pagerequest.endTime = this.creationTime[1];
        }
        await this.$store.dispatch({
            type: 'backstockproduct/getAll',
            data: this.pagerequest
        })

    }
    async settingCost(data: any) {
        this.$store.state.backstockproduct.id = data.id;
        this.settingCostModalShow = true;
    }
    async setshelfcost(data: any) {
        this.$store.state.backstockproduct.id = data.id;
        this.settingshelfupCostModalShow = true;
    }
    async getData() {
        await this.$store.dispatch({
            type: 'backstoreaddress/getAll',
            data: {}
        })
        var a = new storeaddressInfo();
        a.id = null;
        a.storeName = "全部";
        this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
        if (this.storeaddressList.length == 1) {
            this.pagerequest.storeId = this.storeaddressList[0].id;
        }
        else {
            this.storeaddressList.push(a);
            this.pagerequest.storeId = null;
        }
    }
    async showmodel(data: any) {
        this.$store.state.backstockproduct.stockmodel = data;
        this.editModalShow = true;
    }
    async lookskumapping(data: any) {
        this.$store.state.backstockproduct.id = data.id;
        this.lookModalShow = true;
    }
    async showmodels(data: any, type: number) {
        this.$store.state.backstockproduct.id = data.id;
        if (type == 1) {
            //入库总量历史
            this.totalinstockModalShow = true;
        }
        else if (type == 2) {
            //出库总量历史
            this.totaloutstockModalShow = true;
        }
        else {
            //库存量历史
            this.lavestockModalShow = true;
        }
    }
    async printing(data: any) {
        this.$store.state.backstockproduct.barCode = data.barCode;
        this.$store.state.backstockproduct.shelfPosition = (data.shelfPosition ? data.shelfPosition : "") + "_" + data.id;
        this.$store.state.backstockproduct.printCount = 1;
        this.printingModalShow = true;
    }
    async Txm(data: any) {
        this.$store.commit('fontorder/getPdfbyte', {
            barCode: data.barCode,
            shelfPosition: (data.shelfPosition ? data.shelfPosition : "") + "_" + data.id,
            imageUrl: ""
        });
    }
    printTxm(data: any) {
        var LODOP = getLodop();
        if (!this.isLoadPrintList) {
            LODOP.Create_Printer_List(document.getElementById('SelectPrint'));
            this.$Message.success("已加载打印机，请选择指定打印机");
            this.isLoadPrintList = true;
            return;
        }
        var printSelect: any = document.querySelector('#SelectPrint');
        if (!printSelect.value) {
            this.$Message.success("请选择指定打印机");
            return;
        }
        //LODOP.PRINT_INIT("条形码" + data.barCode+ "打印");
        LODOP.SET_PRINTER_INDEX(printSelect);
        LODOP.PRINT_INITA(0, 0, "90mm", "40mm", "打印控件");
        LODOP.SET_PRINT_STYLE("FontSize", 9);
        LODOP.SET_PRINT_STYLE("Bold", 0);
        LODOP.ADD_PRINT_BARCODE("50mm", "30mm", "80mm", "30mm", "EAN128A", this.$store.state.backstockproduct.barcode);//条码
        LODOP.ADD_PRINT_TEXT("37mm", "3mm", "90mm", "1mm", "");
        LODOP.PRINT();//打印
        //LODOP.PREVIEW();//预览
        //LODOP.SET_PRINT_STYLEA(0, data.pList.length, data.pList.length);
    }
    async stockup(data: any) {
        this.$store.state.backstockproduct.id = data.id;
        this.supplyModalShow = true;
    }
    get pageSize() {
        return this.$store.state.backstockproduct.pageSize;
    }
    get totalCount() {
        return this.$store.state.backstockproduct.totalCount;
    }
    get currentPage() {
        return this.$store.state.backstockproduct.currentPage;
    }
    async DisplayAttachment(data: any) {
        window.open(appconst.remoteServiceBaseUrl + "api/File/GetProductAttachment?guid=" + data.attachment + "&id=" + data.userId);
    }
    async PrintAttachment(data: any) {
        var url = appconst.remoteServiceBaseUrl + "api/File/GetProductAttachment?guid=" + data.attachment + "&id=" + data.userId;
        this.$store.state.backstockproduct.pdfUrl = url;
        this.attachmentprintingModalShow = true;
    }
    columns = [
        //{
        //    title: '国内物流单号',
        //     key: 'logisticsNumber',
        //    width: 150,

        //    },

        {
            title: '用户编码',
            key: 'userCode',
            width: 90,
        },
        {
            title: '产品编号',
            key: 'productNo',
            width: 155,
        },
        {
            title: '产品状态',
            key: 'stockStatus',
            width: 100,
            render: (h: any, params: any) => {
                return h('span', Enums.StockStatus.filter(function (item) { return item.value == params.row.stockStatus })[0].name);
            }
        },
        {
            title: '货架位置',
            key: 'shelfPosition',
            width: 100,

        },
        {
            title: '产品内码',
            key: 'id',
            width: 100,
        },
        {
            title: '备货入库仓库',
            key: 'storeName',
            width: 120,
        },
        //{
        //    title: '产品类型',
        //    width: 90,
        //    key: 'productType',
        //    render: (h: any, params: any) => {
        //        return h('span', Enums.ProductType.filter(function (item) { return item.value == params.row.productType })[0].name);
        //    }
        //    },
        {
            title: '产品图片',
            key: 'productImgGuid',
            width: 95,
            render: (h: any, params: any) => {
                if (params.row.productImgGuid) {
                    var data = { imageGuid: params.row.productImgGuid, url: null };
                    var url = "";
                    if (params.row.productImgGuid.indexOf("http") != -1) {
                        url = params.row.productImgGuid;
                    }
                    else {
                        this.$store.commit('expressuserinfo/getImgUrl', data);
                        url = data.url;
                    }
                    return h('img', {
                        style: {
                            width: "50px",
                            height: "50px",
                            verticalAlign: "middle"
                        },
                        attrs: {
                            src: url,
                            preview: "yc_" + params.row.id,
                            "preview-text": params.row.orderNumber + "cp"
                        }
                    });

                } else {
                    return h('span', "");
                }
            }
        },
        {
            title: '产品Sku',
            key: 'productSku',
            width: 100,
        },
        {
            title: '商品名称',
            key: 'productName',
            width: 200,
        },
        {
            title: '贴标信息',
            key: 'lableInfo',
            width: 100,
        },
        {
            title: '组合',
            key: 'isCombination',
            width: 70,
            render: (h: any, params: any) => {
                return h('span', params.row.isCombination ? "是" : "否",
                )
            }
        },
        {
            title: '组合信息',
            key: 'isCombination',
            width: 230,
            render: (h: any, params: any) => {
                if (!params.row.items || params.row.items.length === 0) {
                    return h('span', { style: { color: '#c5c8ce' } }, '');
                }

                return h('div', params.row.items.map((item: any) => {
                    return h('div', {
                        style: {
                            marginBottom: '4px',
                            fontSize: '12px',
                            lineHeight: '1.4'
                        }
                    }, [
                        h('span', {
                            style: {
                                color: '#515a6e',
                                fontWeight: 'bold'
                            }
                        }, item.productNo || '未知'),
                        h('font', {
                            style: {
                                color: 'red',
                                margin: '0 2px'
                            }
                        }, '*'),
                        h('span', {
                            style: {
                                color: '#808695'
                            }
                        }, `${item.count || 0}`),
                        h('span', {
                            style: {
                                color: '#19be6b',
                                marginLeft: '4px',
                                fontSize: '11px'
                            }
                        }, `库存:${item.inventory || 0}`)
                    ]);
                }));
            }
        },
        {
            title: '预囤货总量',
            key: 'preStockNum',
            width: 100,

        },
        {
            title: '安全库存',
            key: 'safeStock',
            width: 100,
        },
        {
            title: '入库总量',
            key: 'totalStorage',
            width: 100,
            render: (h: any, params: any) => {
                var a = 'red';
                return h('a', { on: { click: () => { this.showmodels(params.row, 1) } }, style: { color: a, 'text-decoration': 'underline' } }, params.row.totalStorage);
            }
        },
        {
            title: '出库总量',
            key: 'totalOutgoing',
            width: 100,
            render: (h: any, params: any) => {
                var a = 'red';
                return h('a', { on: { click: () => { this.showmodels(params.row, 2) } }, style: { color: a, 'text-decoration': 'underline' } }, params.row.totalOutgoing);
            }
        },
        {
            title: '库存量',
            key: 'inventory',
            width: 80,
            render: (h: any, params: any) => {
                var a = 'red';
                return h('a', { on: { click: () => { this.showmodels(params.row, 3) } }, style: { color: a, 'text-decoration': 'underline' } }, params.row.inventory);
            }
        },
        {
            title: '在途库存量',
            key: 'inTransitStock',
            width: 100,

        },
        {
            title: '采购价格',
            key: 'purchaseCost',
            width: 100,

        },
        {
            title: '第三方平台Sku映射',
            key: '',
            width: 150,
            render: (h: any, params: any) => {
                var a = 'red';
                return h('a', { on: { click: () => { this.lookskumapping(params.row) } }, style: { color: a, 'text-decoration': 'underline' } }, "查看");
            }
        },
        {
            title: '附件',
            key: '',
            width: 100,
            render: (h: any, params: any) => {
                var _this = this;
                return h('div', [
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            width: '70px',
                            height: '30px',
                            display: params.row.attachment ? "inline-block" : "none",
                        },
                        on: {
                            click: () => {
                                _this.DisplayAttachment(params.row);

                            }
                        }

                    }, "附件查看"),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            width: '70px',
                            height: '30px',
                            display: params.row.attachment ? "inline-block" : "none",
                        },
                        on: {
                            click: () => {
                                _this.PrintAttachment(params.row);

                            }
                        }

                    }, "附件打印"),
                    h('Upload', {
                        props: {
                            action: appconst.remoteServiceBaseUrl + "api/services/app/BackStockProduct/UploadAttachment?productId=" + params.row.id, // 上传地址
                            accept: '.pdf', // 接受的文件类型
                            multiple: false, // 是否支持多文件上传
                            showUploadList: false, // 是否显示文件列表
                            headers: {
                                "Authorization": "Bearer " + window.abp.auth.getToken(),
                                ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
                                "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
                            }
                        },
                        style: {
                            color: 'blur',
                            icon:"ios-cloud-upload-outline"
                        },
                       
                        on: {
                            'on-success': (response, file) => {
                                params.row.attachment = response.result;
                            },
                            'on-error': (error, file) => {
                                this.$Message.error('上传PDF失败。');
                            },
                        },
                    },"附件上传")
                ]);
            }
        },
        //{
        //    title: '货架位置',
        //    key: 'shelfPosition',
        //    width: 100,
        //},
        {
            title: '扣费详情',
            width: 280,
            render: (h: any, params: any) => {
                return h('div', [h('h3', "开始扣费时间:" + (params.row.beginDeductionTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.beginDeductionTime)))), h('h3', "扣费周期:" + (params.row.deductionCycle == null ? "" : params.row.deductionCycle + "天")), h('h3', "扣除积分/周期:" + (params.row.deductIntegral == null ? "" : params.row.deductIntegral + "积分")), h('h3', "上架费:" + (params.row.onlyOneShelfCost == null ? "" : params.row.onlyOneShelfCost + "积分"))])
            }
        },


        //{
        //    title: '商品链接',
        //    key: 'productLink',            //{
        //    title: '开始扣费时间',
        //    key: 'beginDeductionTime',
        //    width: 150,
        //    render: (h: any, params: any) => {
        //        return h('span', params.row.beginDeductionTime == null ? "" :DateUtils.formatLongDate(new Date(params.row.beginDeductionTime)));
        //    }
        //},
        //{
        //    title: '扣费积分',
        //    key: 'deductIntegral',
        //    width: 200,
        //},
        //{
        //    title: '扣费周期/积分',
        //    key: 'deductionCycle',
        //    width: 200,
        //},
        //    width: 200,
        //},

        //{
        //    title: '商品数量',
        //    key: 'productNums',
        //    width: 200,
        //},
        //{
        //    title: '采购成本',
        //    key: 'purchaseCost',
        //    width: 200,
        //},

        {
            title: '操作',
            width: 130,
            fixed: 'left',
            key: 'id',
            render: (h: any, params: any) => {
                var data = params.row;
                var _this = this;
                return h('div', [
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            width: '100px',
                            height: '30px',
                            display: params.row.beginDeductionTime == null ? "inline-block" : "none",
                        },
                        on: {
                            click: () => {
                                _this.settingCost(params.row);

                            }
                        }

                    }, "设置仓储费"),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            width: '100px',
                            height: '30px',
                            display: params.row.onlyOneShelfCost == null ? "inline-block" : "none",
                        },
                        on: {
                            click: () => {
                                _this.setshelfcost(params.row);

                            }
                        }

                    }, "设置上架费"),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            width: '100px',
                            height: '30px',
                            display: params.row.beginDeductionTime && params.row.onlyOneShelfCost ? "inline-block" : "none",
                        },
                        on: {
                            click: () => {
                                _this.Txm(params.row);

                            }
                        }

                    }, "查看条形码"),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            width: '100px',
                            height: '30px',
                            display: params.row.beginDeductionTime && params.row.onlyOneShelfCost ? "inline-block" : "none",
                        },
                        on: {
                            click: () => {
                                _this.printing(params.row);

                            }
                        }

                    }, "打印条形码"),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            width: '100px',
                            height: '30px',
                        },
                        on: {
                            click: () => {
                                _this.InputStockNum(params.row);

                            }
                        }

                    }, "修改库存"),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            width: '100px',
                            height: '30px',
                        },
                        on: {
                            click: () => {
                                _this.EditShelfPosition(params.row);

                            }
                        }

                    }, "修改产品信息"),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            width: '100px',
                            height: '30px',
                            marginBottom: '5px',
                        },
                        on: {
                            click: () => {
                                _this.EditStockNum(params.row);

                            }
                        }

                    }, "编辑预囤货量"),
                ]);
            }
        }
    ]
    async created() {
        this.getData();
        this.getpage();
    }
}
